// extracted by mini-css-extract-plugin
module.exports = {"colourBar":"ColourRampBar_colourBar__3papO"};